import { render, staticRenderFns } from "./activeText-editor.vue?vue&type=template&id=2684f3ad&scoped=true&"
import script from "./activeText-editor.vue?vue&type=script&lang=js&"
export * from "./activeText-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2684f3ad",
  null
  
)

export default component.exports